export default __webpack_public_path__ + "static/media/pen.1f59195d.svg";